import { Link, useLocation, useNavigate } from "react-router-dom";
import { Youtube, Globe, Heart } from "lucide-react";
import { scrollToHash } from "@/components/Navbar";

const SECTION_LINKS = [
  { label: "Episodes", href: "#episodes", testid: "footer-link-episodes" },
  { label: "BUBZ+", href: "#bubzplus", testid: "footer-link-bubzplus" },
  { label: "Creator", href: "#creator", testid: "footer-link-creator" },
];

const PAGE_LINKS = [
  { label: "Pop Game", to: "/game", testid: "footer-link-game" },
  { label: "Coloring", to: "/coloring", testid: "footer-link-coloring" },
];

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const go = (e, href) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: href } });
    } else {
      scrollToHash(href);
    }
  };

  return (
    <footer data-testid="footer" className="bg-bubz-ink pb-10 pt-16 text-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-center">
          <div className="flex items-center gap-3">
            <img
              src="/logo.png"
              alt="BUBZ & BUBBLES official logo"
              className="h-16 w-auto drop-shadow-[0_0_18px_rgba(255,255,255,0.25)]"
            />
            <p className="text-sm font-semibold text-white/50">A J.J. STONE original series</p>
          </div>

          <nav className="flex flex-wrap gap-x-6 gap-y-2">
            {SECTION_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={l.testid}
                onClick={(e) => go(e, l.href)}
                className="text-sm font-extrabold text-white/70 transition-colors hover:text-bubz-sun"
              >
                {l.label}
              </a>
            ))}
            {PAGE_LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={l.testid}
                className="text-sm font-extrabold text-white/70 transition-colors hover:text-bubz-sun"
              >
                {l.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              data-testid="footer-youtube-link"
              href="https://www.youtube.com/@BUBZPLUSSTREAMINGSERVICE"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="BUBZ & BUBBLES on YouTube"
              className="flex h-12 w-12 items-center justify-center rounded-full bg-white/10 transition-colors hover:bg-[#FF0000]"
            >
              <Youtube size={20} />
            </a>
            <a
              data-testid="footer-bubzplus-link"
              href="https://www.bubzplus.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="BUBZ+ streaming service"
              className="flex h-12 w-12 items-center justify-center rounded-full bg-white/10 transition-colors hover:bg-bubz-sky"
            >
              <Globe size={20} />
            </a>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 text-xs font-bold text-white/40 sm:flex-row">
          <p>© 2026 BUBZ &amp; BUBBLES · Created by J.J. STONE · All rights reserved</p>
          <p className="flex items-center gap-1.5">
            Made with <Heart size={12} className="text-bubz-pink" fill="currentColor" /> and lots of soap bubbles
          </p>
        </div>
      </div>
    </footer>
  );
}
